import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

// Returns { seasons: [{id,label}], currentSeason: 'S12'|null }. currentSeason
// is authoritative from the backend (the only place season classification
// logic lives) — never computed client-side.
export async function getAdminSeasons() {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/seasons`, {
        headers,
    });
    return data;
}
